export const ApiPathEnum = {
  get_patient_list: '/v1/patients/all',
  get_lead_list: '/questionnaire-submission/list',
  post_custom_review_config: '/customize/review',
  get_custom_review_config: '/review/get/review/configdata/',
  post_setup_review_destination: '/review/setup/destination',
  get_setup_review_destination: '/review/get/review/destination/',
  getServicesByClinicId: (id: number) => `/v1/services/dropDown?clinicId=${id}`,
};
